import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, FileTextIcon, TrendingUpIcon, BarChart2Icon } from 'lucide-react';
const Platform = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="flex-grow bg-gray-50" data-id="element-353">
      {/* Hero Section */}
      <div className="bg-primary pt-20 pb-24 text-center px-4 sm:px-6 lg:px-8" data-id="element-354">
        <div className="max-w-3xl mx-auto" data-id="element-355">
          <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl" data-id="element-356">
            The Complete AEO/GEO Platform
          </h1>
          <p className="mt-6 text-xl text-textlight" data-id="element-357">
            Monitor, optimize, and grow your brand's visibility across every
            major AI search engine from a single, unified dashboard.
          </p>
        </div>
      </div>

      {/* Features Grid */}
      <div className="max-w-7xl mx-auto py-20 px-4 sm:px-6 lg:px-8" data-id="element-358">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-359">
          {/* Feature 1 */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-360">
            <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center mb-6" data-id="element-361">
              <SearchIcon className="w-6 h-6 text-accent" data-id="element-362" />
            </div>
            <h3 className="text-xl font-bold text-customblack mb-3" data-id="element-363">
              AI Search Monitoring
            </h3>
            <p className="text-customgray leading-relaxed" data-id="element-364">
              Track brand mentions across ChatGPT, Perplexity, Google AI
              Overviews, and Gemini in real-time. Know exactly when and how your
              brand is being recommended by AI.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-365">
            <div className="w-12 h-12 rounded-xl bg-accentwarm/10 flex items-center justify-center mb-6" data-id="element-366">
              <FileTextIcon className="w-6 h-6 text-accentwarm" data-id="element-367" />
            </div>
            <h3 className="text-xl font-bold text-customblack mb-3" data-id="element-368">
              Content Optimization
            </h3>
            <p className="text-customgray leading-relaxed" data-id="element-369">
              Get AI-powered recommendations to make your content highly citable
              by generative engines. Optimize schema markup, structure, and
              formatting automatically.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-370">
            <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center mb-6" data-id="element-371">
              <TrendingUpIcon className="w-6 h-6 text-blue-500" data-id="element-372" />
            </div>
            <h3 className="text-xl font-bold text-customblack mb-3" data-id="element-373">
              Competitive Intelligence
            </h3>
            <p className="text-customgray leading-relaxed" data-id="element-374">
              See how competitors rank in AI search results. Identify content
              gaps where competitors are cited but you aren't, and build
              strategies to win share of voice.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-375">
            <div className="w-12 h-12 rounded-xl bg-purple-500/10 flex items-center justify-center mb-6" data-id="element-376">
              <BarChart2Icon className="w-6 h-6 text-purple-500" data-id="element-377" />
            </div>
            <h3 className="text-xl font-bold text-customblack mb-3" data-id="element-378">
              Analytics & Reporting
            </h3>
            <p className="text-customgray leading-relaxed" data-id="element-379">
              Comprehensive dashboards tracking your overall visibility scores,
              sentiment trends, and estimated traffic impact from AI search
              engines over time.
            </p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-white border-t border-gray-200 py-16 text-center px-4" data-id="element-380">
        <h2 className="text-3xl font-bold text-customblack mb-6" data-id="element-381">
          Ready to see it in action?
        </h2>
        <Link to="/demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg text-white bg-accent hover:bg-cyan-400 transition-colors shadow-lg" data-id="element-382">
          Book a Personalized Demo
        </Link>
      </div>
    </main>;
};
export default Platform;